/* eslint-disable no-underscore-dangle */
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  E2E_COMMS_WRAPPER_ID,
  getE2ePageIdForPathname,
  isE2eCommsEnabled,
} from '../../utils/e2eComms.js';

/**
 * Mounts the E2E alert banner on supported auth routes (signin, signup, forgot-unpw).
 */
export default function useE2eCommsBanner() {
  const { pathname } = useLocation();
  const [isE2EScriptLoaded, setIsE2EScriptLoaded] = useState(false);

  useEffect(() => {
    if (!isE2eCommsEnabled()) return undefined;

    const markLoaded = () => setIsE2EScriptLoaded(true);
    if (document.readyState === 'complete') {
      markLoaded();
    } else {
      window.addEventListener('load', markLoaded);
    }
    return () => window.removeEventListener('load', markLoaded);
  }, []);

  useEffect(() => {
    if (!isE2eCommsEnabled() || !isE2EScriptLoaded) return undefined;

    const pageId = getE2ePageIdForPathname(pathname);
    const wrapper = document.getElementById(E2E_COMMS_WRAPPER_ID);

    try {
      if (pageId && window._e2e_comms) {
        window._e2e_comms.page = pageId;
        window._e2e_comms.add(wrapper);
        return () => {
          window._e2e_comms?.remove(wrapper);
        };
      }
      window._e2e_comms?.remove(wrapper);
    } catch (e) {
      console.log(e);
    }
    return undefined;
  }, [pathname, isE2EScriptLoaded]);
}
